<template>
<div>
  <v-simple-table dense>
    <template v-slot:default>
        <thead>
          <tr class="heading">
            <th width="1%" class="text-center">#</th>
            <th width="8%" class="text-center">نوع</th>
            <th width="56%" class="text-center">جزئیات</th>
            <th width="17%" class="text-center">مبلغ</th>
            <th width="8%" class="text-center">توضیحات</th>
            <th width="7%" class="text-center">عملیات</th>
            <th width="1%" class="text-center">بانک</th>
            <th width="1%" class="text-center">سیستم</th>
            <th width="1%" class="text-center">سند</th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(item, index) in items">
            <tr class="item" :key="item.row_id" v-if="!item.discount" :class="{
              'orange lighten-3': item.type === 'bankReceipt' && item.checkBill > 1 && item.checkHB == 0,
              'red lighten-3': (item.type === 'pos' && (item.checkHB > 0 || item.checkDoc > 0)) || (item.type === 'bankReceipt' && (item.checkBill == 0 || item.checkHB > 0 || item.checkDoc > 0)) ,
              'green lighten-3': (item.type === 'pos' && item.checkHB == 0 && item.checkDoc == 0) || (item.type === 'bankReceipt' && item.checkBill == 1 && item.checkHB == 0 && item.checkDoc == 0)
            }">
            <td id="pt">{{index + 1}}</td>
            <td><MyRpType v-model="item.type" :route="route" @change="editRpRow($event, index)"/></td>
            <td>
              <v-row>
                <v-col cols="12" md="4" v-if="['pos', 'bankReceipt'].includes(item.type)">
                  <MyBankaccounts v-model="item.bank_account_id" :type="item.type" @blur="checkBill(index);checkHB(index);checkDoc(index)"/>
                </v-col>

                <v-col cols="12" md="2" v-if="item.type === 'cheque'">
                  <MyBanks v-model="item.bank_id"/>
                </v-col>

                <v-col cols="12" md="4" v-if="item.type === 'cash'">
                  <MyBoxes v-model="item.box_id"/>
                </v-col>

                <v-col cols="12" md="2" v-if="item.type !== 'cash'">
                  <MyNumber required label="سریال" v-model="item.serial" maxLength="15" @blur="checkBill(index);checkHB(index);checkDoc(index)" counter/>
                </v-col>

                <v-col cols="12" md="3" v-if="item.type !== 'cash'">
                  <JalaliDateInput v-model="item.date" label="تاریخ فیش/چک" :defaultValue="index > 0 && formState !== 'edit' ? items[index-1].date : ''" @blur="checkBill(index);checkHB(index);checkDoc(index)"/>
                </v-col>

                <v-col cols="12" md="3" v-if="item.type === 'cheque'">
                  <MyNumber label="شماره حساب" v-model="item.number"  maxLength="15"/>
                </v-col>

                <v-col cols="12" md="2" v-if="item.type === 'cheque'">
                  <v-text-field label="شعبه" v-model="item.branch" type="text" counter maxLength="15"></v-text-field>
                </v-col>

                <v-col cols="12" md="3"  v-if="route === 'payments' && item.type === 'bankReceipt'">
                  <MyCurrency :required='false' label="کارمزد" v-model="item.fee"/>
                </v-col>
              </v-row>
            </td>
            <td>
              <v-col class="mt-n3">
                <MyCurrency v-model="item.price" @blur="checkBill(index);checkHB(index);checkDoc(index)"/>
              </v-col>
            </td>
            <td><MyComment label='توضیحات' v-model="item.comment" /></td>
            <td id="pt">
              <v-icon color="success" class="mr-2" @click="addRpRow(item)">
                mdi-plus
              </v-icon>
              <v-icon color="red darken-2" class="mr-2" @click='removeRpRow(item)' v-if="items.length > 2">
                mdi-delete
              </v-icon>
              <!-- <v-icon color="orange" class="mr-2" @click='checkDoc(item)'>
                mdi-check
              </v-icon> -->
            </td>
            <td id="pt" :class="{
              'red lighten-3': item.type === 'bankReceipt' && item.checkBill == 0 ,
              'orange lighten-3': item.type === 'bankReceipt' && item.checkBill > 1 ,
              'green lighten-3': item.type === 'bankReceipt' && item.checkBill == 1
            }">{{item.checkBill}}</td>
            <td id="pt" :class="{
              'red lighten-3': (item.type === 'pos' || item.type === 'bankReceipt') && item.checkHB > 0 ,
              'green lighten-3': (item.type === 'pos' || item.type === 'bankReceipt') && item.checkHB == 0
            }">{{item.checkHB}}</td>
            <td id="pt" :class="{
              'red lighten-3': (item.type === 'pos' || item.type === 'bankReceipt') && item.checkDoc > 0 ,
              'green lighten-3': (item.type === 'pos' || item.type === 'bankReceipt') && item.checkDoc == 0
            }">{{item.checkDoc}}</td>
          </tr>
        </template>

    <tr class="total">
      <td colspan="3">جمع مبالغ</td>
      <td colspan="6">{{ rpTotal | currencyDisplay }}</td>
    </tr>

    <template v-for="(item) in items">
        <tr class="item" :key="item.row_id" v-if="item.discount">
          <td colspan="3">
            <v-row>
              <v-col cols="12" md="10">
              </v-col>
              <v-col cols="12" md="2">
                <MyDiscount v-model="item.discount" />
              </v-col>
            </v-row>
          </td>
          <td colspan="6">
            <v-row>
              <v-col cols="12" md="6">
                <DiscountPrice v-model="item.price" :total="rpTotal" :route="route" :discountLabel="item.discount.label" />
              </v-col>
            </v-row>
          </td>
        </tr>
    </template>

    <tr class="total">
      <td colspan="3">مبلغ سند</td>
      <td colspan="6">{{ rpPrice | currencyDisplay }}</td>
    </tr>

    </tbody>
    </template>
  </v-simple-table>
</div>
</template>

<script>
import MyRpType from './MyRpType.vue'
import MyBankaccounts from '../../components/MyBankaccounts.vue'
import MyBanks from '../../components/MyBanks.vue'
import MyBoxes from '../../components/MyBoxes.vue'
import MyNumber from '../../components/MyNumber.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import DiscountPrice from '../../components/Discount‌Price.vue'
import MyComment from '../../components/MyComment.vue'
import MyDiscount from '../../components/MyDiscount.vue'
import JalaliDateInput from '../../components/JalaliDateInput.vue'
//
export default {
  name: 'rpTable',
  data() {
    return {}
  },
  props: [
    'route', 'items', 'rpTotal', 'rpPrice', 'addRpRow', 'editRpRow', 'removeRpRow',
    'checkBill', 'checkHB', 'checkDoc',
    // 'discountDefaultValue', 'getDiscountPriceFocus',
  ],
  created() {
    this.formState = this.$router.currentRoute.path.split('/')[2]
  },
  components: {
    MyRpType,
    MyBankaccounts,
    MyBanks,
    MyBoxes,
    MyNumber,
    MyCurrency,
    DiscountPrice,
    MyComment,
    MyDiscount,
    JalaliDateInput,
  },
}
</script>
